import React from 'react';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'default' | 'white' | 'muted' | 'dark';
}
export function SectionWrapper({
  children,
  className = '',
  id,
  background = 'default'
}: SectionWrapperProps) {
  const bgColors = {
    default: 'bg-white',
    white: 'bg-white',
    muted: 'bg-slate-50',
    dark: 'bg-slate-900'
  };
  return <section id={id} className={`py-16 md:py-24 px-6 md:px-8 ${bgColors[background]} ${className}`} data-id="element-312">
      <div className="max-w-6xl mx-auto w-full" data-id="element-313">{children}</div>
    </section>;
}